var React = require('react');

function MinusGrey (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 3.2C0 2.0799 0 1.51984 0.217987 1.09202C0.409734 0.715695 0.715695 0.409734 1.09202 0.217987C1.51984 0 2.0799 0 3.2 0H20.8C21.9201 0 22.4802 0 22.908 0.217987C23.2843 0.409734 23.5903 0.715695 23.782 1.09202C24 1.51984 24 2.0799 24 3.2V20.8C24 21.9201 24 22.4802 23.782 22.908C23.5903 23.2843 23.2843 23.5903 22.908 23.782C22.4802 24 21.9201 24 20.8 24H3.2C2.0799 24 1.51984 24 1.09202 23.782C0.715695 23.5903 0.409734 23.2843 0.217987 22.908C0 22.4802 0 21.9201 0 20.8V3.2Z","fill":"#DBE0E4","key":0}),React.createElement("path",{"d":"M14.4001 12H9.6001","stroke":"#041C1B","strokeLinecap":"square","strokeLinejoin":"round","key":1})]);
}

MinusGrey.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MinusGrey;

MinusGrey.default = MinusGrey;
